import { CharKeys } from "../../state";

// For text sizes are group 0-1:S, 2-3:M, 4-5:L, none:X
const Dominate = {
  // fucker organ
  [CharKeys.prowessTypes.tongue]: {
    sizeOpt: false,
    sizeX: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### wet tongue over xxxx's face`,
          `++++ licks xxxx's soft thighs, biting #### hungrily`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ licks xxxx's little tits, roughly nipping ==== breast meat`,
          `++++ violently slaps xxxx's tits and proceeds to slather ==== nipples with spit`,
        ],
        sizeM: [
          `++++ licks energetically between xxxx's tits, spitting on ==== chest for extra wetness`,
          `++++ spits over xxxx's lovely nipples, then sucks it off hungrily`,
        ],
        sizeL: [
          `++++'s face is buried as she roughly motorboats #### face, before nipping those big breasts`,
          `++++ nips xxxx's solid nipples, before batting them with ==== tongue`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ spits into xxxx's little throat, then pushes #### tongue in`,
          `++++ slaps #### wet tongue on xxxx's tongue, fighting for control of ==== mouth`,
          `++++ jams #### fat tongue between xxxx's lips`,
          `++++ dribbles #### saliva into xxxx's mouth`,
          `++++ runs #### explorative tongue eagerly around xxxx's mouth`,
          `++++ pushes #### tongue into xxxx's mouth`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ evelopes xxxx's small cock with #### mouth, sucking ==== hungrily `,
          `++++ slaps xxxx's cute cock with #### tongue, running it around ==== glans`,
        ],
        sizeM: [
          `++++ rubs #### tongue dominantly against xxxx's beefy cock`,
          `++++ slaps xxxx's big cock with #### tongue, before pushing it into #### mouth`,
        ],
        sizeL: [
          `++++ hungrily gags herself on the massive member, while pumping it roughly`,
          `++++ slaps xxxx's cock around, before pumping it steadily, wetting the glans with #### tongue`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ sucks xxxx's clit with #### mouth`,
          `++++ rubs xxxx's pussy with the tip of #### tongue`,
          `++++ pushes #### tongue deep into xxxx's pussy, exploring it's depths`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ fucks xxxx's backdoor with #### tongue`,
          `++++ slather xxxx's arse with spit and saliva, teasing the edge with #### tongue`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.touch]: {
    sizeOpt: false,
    sizeX: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### hands over xxxx's neck, slowly tightening #### grip`,
          `++++ rubs against xxxx's body roughly, pushing ==== into the floor`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ squeezes xxxx's little tits, roughly kneading ==== small breast meat`,
          `++++ violently slaps xxxx's tits, and pinches ==== nipples`,
        ],
        sizeM: [
          `++++ roughly gropes xxxx's tits, and squeezes ==== nipples`,
          `++++ spits on ==== hands before kneading xxxx's breasts roughly and flicking ==== lovely nipples`,
        ],
        sizeL: [
          `++++ slaps ==== big breasts, and meanly crushes ==== breast meat`,
          `++++ tugs on xxxx's solid nipples, before slapping them about`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ pushes #### hand into xxxx's throat, releasing ==== saliva, and triggering ==== gag reflex`,
          `++++ tugs roughly on ==== lips, demeaning ==== for being a little slut`,
          `++++ slaps ==== face around, tells ==== to call #### master from now on`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ evelopes xxxx's small cock with #### hands, squeezing aggressively`,
          `++++ slaps xxxx's cute cock with #### hand, then rubs ==== glans`,
        ],
        sizeM: [
          `++++ dominantly pumps xxxx's beefy cock`,
          `++++ slaps xxxx's big cock, before squeezing ==== balls`,
        ],
        sizeL: [
          `++++ gets a solid two-handed grip, before pumping ==== massive cock roughly`,
          `++++ slaps xxxx's cock around, before pumping it steadily, squeezing it uncomfortably tightly`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ sucks xxxx's clit with #### mouth`,
          `++++ rubs xxxx's pussy with the tip of #### tongue`,
          `++++ pushes #### tongue deep into xxxx's pussy, exploring it's depths`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ fucks xxxx's backdoor with #### tongue`,
          `++++ slather xxxx's arse with spit and saliva, teasing the edge with #### tongue`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.cock]: {
    sizeOpt: 3,
    // text varies by organ size, grouped into three
    sizeS: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### small cock over xxxx's face`,
          `++++ dry humps xxxx's soft thighs`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### small cock roughly between xxxx's little tits`,
          `++++ slaps #### cute cock violently on xxxx's soft thighs`,
        ],
        sizeM: [
          `++++ jams #### little cock between, xxxx's tits, fucking them energetically`,
          `++++ runs #### precum covered glans over xxxx's lovely nipples`,
        ],
        sizeL: [
          `++++'s little cock is enveloped in xxxx's busty rack`,
          `++++ pushes #### cock hard against xxxx's solid nipples`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: 3,
        sizeS: [
          `++++ jams #### small cock into xxxx's little throat`,
          `++++ slaps #### cute cock on xxxx's tongue`,
        ],
        sizeM: [
          `++++ jams #### little cock between xxxx's lips`,
          `++++ holds #### precum covered cock in xxxx's mouth`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's mouth`,
          `++++ pushes #### cock into xxxx's mouth`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ crushed #### small cock against xxxx's`,
          `++++ slaps xxxx's cute cock with #### own`,
        ],
        sizeM: [
          `++++ rubs dominantly against xxxx's beefier cock`,
          `++++ slaps xxxx's bigger cock with #### own`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's`,
          `++++ pushes #### cock under xxxx's foreskin, rubbing it around`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's clit with #### small cock`,
          `++++ batters xxxx's pussy with #### cute cock`,
        ],
        sizeM: [
          `++++ rubs dominantly against xxxx's clit`,
          `++++ slaps xxxx's pussy lips with #### erect cock`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's pussy`,
          `++++ pushes #### cock into xxxx's pussy, rubbing it around`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's backdoor with #### small cock`,
          `++++ batters xxxx's arse with #### cute cock`,
        ],
        sizeM: [
          `++++ rubs dominantly against xxxx's back door`,
          `++++ slaps xxxx's second cunt with #### cock`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's arse entrance`,
          `++++ pushes #### cock into xxxx's arse, degrading ==== for ==== gaping hole`,
        ],
      },
    },
    sizeM: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### hard cock over xxxx's face, pressing the pugent member beneath ==== nose`,
          `++++ rubs #### pre-cum dribbling dick over xxxx's chest`,
          `++++ fucks xxxx's soft thighs`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ pounds #### fat cock roughly between xxxx's tiny tits`,
          `++++ slaps #### hard cock violently accross xxxx's soft breasts`,
        ],
        sizeM: [
          `++++ jams #### ready cock between xxxx's tits, fucking them roughly`,
          `++++ pushes #### precum covered glans into xxxx's lovely nipples`,
        ],
        sizeL: [
          `++++'s fat member is enveloped in xxxx's busty rack`,
          `++++ grabs xxxx's breasts and roughly fucks ==== rack`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: 3,
        sizeS: [
          `++++ jams #### pulsing cock into xxxx's tight throat`,
          `++++ slaps #### dick on xxxx's tongue`,
          `++++ holds xxxx's head while stuffing #### hard cock into ==== mouth`,
          `Grabbing xxxx by the hair, ++++ fucks ==== face roughly`,
          `++++ skull fucks xxxx, choking ==== on #### dick`,
        ],
        sizeM: [
          `++++ jams #### fat cock between xxxx's lips`,
          `++++ holds #### precum covered cock in xxxx's mouth`,
          `++++ slaps #### dick on xxxx's big tongue`,
          `++++ holds xxxx's head while stuffing #### hard cock into ==== mouth`,
          `Grabbing xxxx by the hair, ++++ fucks ==== face roughly`,
          `++++ skull fucks xxxx, gagging ==== on #### dick`,
        ],
        sizeL: [
          `++++'s meaty cock is rubbed around xxxx's mouth`,
          `++++ pushes #### cock into xxxx's mouth`,
          `++++ holds xxxx's head while stuffing #### hard cock into ==== mouth`,
          `Grabbing xxxx by the hair, ++++ fucks ==== face unmercifully`,
          `++++ skull fucks xxxx, like #### hates ====`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ crushed #### cock against xxxx's tiny one`,
          `++++ slaps xxxx's cute cock with #### own, fatter cock`,
        ],
        sizeM: [
          `++++ rubs dominantly against xxxx's cock`,
          `++++ slaps xxxx's cock with #### own`,
        ],
        sizeL: [
          `'s cock is rubbed around xxxx's`,
          `++++ pushes #### cock under xxxx's foreskin, rubbing it around`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's clit with #### ready cock`,
          `++++ batters xxxx's pussy with #### swollen cock`,
          `++++ pushes #### way roughly into xxxx's tight cunt`,
          `++++ forces #### fat cock between xxxx's tight pussy lips`,
        ],
        sizeM: [
          `++++ rubs xxxx's clit dominantly`,
          `++++ slaps xxxx's pussy lips with #### erect cock`,
          `++++ fucks xxxx's cunt roughly`,
        ],
        sizeL: [
          `++++'s little cock is rubbed around xxxx's pussy`,
          `++++ pushes #### cock into xxxx's pussy, rubbing it around`,
          `++++ pushes #### way roughly into xxxx's juicy cunt`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's backdoor`,
          `++++ batters xxxx's arse with #### hungry cock`,
          `++++ pushes #### way roughly into xxxx's tight arse`,
          `++++ grabs xxxx's arse cheeks and forces #### fat cock into xxxx's tight back passage`,
        ],
        sizeM: [
          `++++ rubs ====self dominantly between xxxx's arsecheeks`,
          `++++ slaps xxxx's second cunt with #### cock`,
          `++++ pushes #### way roughly into xxxx's warm arse`,
          `++++ grabs xxxx's arse cheeks and forces #### fat cock into xxxx's fresh back passage`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's arse entrance`,
          `++++ pushes #### cock into xxxx's arse, degrading ==== for ==== gaping hole`,
          `++++ pushes #### way roughly into xxxx's loose arse`,
          `++++ grabs xxxx's arse cheeks and pushes #### fat cock into xxxx's open back passage`,
        ],
      },
    },
    sizeL: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### massive cock over xxxx's face, pressing the pugent member beneath ==== nose`,
          `++++ rubs #### pre-cum dribbling dick over xxxx's chest`,
          `++++ fucks xxxx's soft thighs`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ pounds #### giant cock roughly between xxxx's tiny tits`,
          `++++ slaps #### hard cock violently accross xxxx's soft breasts`,
        ],
        sizeM: [
          `++++ jams #### massive cock between xxxx's tits, fucking them roughly`,
          `++++ pushes #### precum covered glans into xxxx's lovely nipples`,
        ],
        sizeL: [
          `++++'s giant swollen member is enveloped in xxxx's busty rack`,
          `++++ grabs xxxx's breasts and roughly fucks ==== rack, with #### giant meaty pole`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: 3,
        sizeS: [
          `++++ jams #### giant cock into xxxx's tight throat, trying to force #### fat member in`,
          `++++ slaps #### fearinducingly big dick on xxxx's tongue`,
          `++++ holds xxxx's head while stuffing #### giant cock into ==== tiny mouth`,
          `Grabbing xxxx by the hair, ++++ fucks ==== tight little mouth roughly`,
          `++++ skull fucks xxxx, choking ==== on #### enourmous dick`,
        ],
        sizeM: [
          `++++ jams #### enourmous cock between xxxx's lips`,
          `++++ holds #### enourmous, precum covered cock in xxxx's mouth`,
          `++++ slaps #### giant dick on xxxx's big tongue`,
          `++++ holds xxxx's head while stuffing #### enourmous cock into ==== mouth`,
          `Grabbing xxxx by the hair, ++++ fucks ==== face roughly`,
          `++++ skull fucks xxxx, gagging ==== on #### giant dick`,
        ],
        sizeL: [
          `++++'s enourmous cock is rubbed around xxxx's mouth`,
          `++++ pushes #### enourmous cock into xxxx's mouth`,
          `++++ holds xxxx's head while stuffing #### giatn, hard cock into ==== mouth`,
          `Grabbing xxxx by the hair, ++++ fucks ==== face unmercifully`,
          `++++ skull fucks xxxx, like #### hates ====`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ crushed #### enourmous cock against xxxx's tiny one`,
          `++++ slaps xxxx's cute cock with #### own, enourmous cock`,
        ],
        sizeM: [
          `++++ rubs dominantly against xxxx's cock`,
          `++++ slaps xxxx's cock with #### own giant one`,
        ],
        sizeL: [
          `'s cock is rubbed around xxxx's`,
          `++++ pushes #### cock against xxxx's, rubbing it dominantly`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's clit with #### enourmous, ready cock`,
          `++++ batters xxxx's tight pussy with #### swollen cock`,
          `++++ pushes #### gaint meatstick roughly into xxxx's tight cunt`,
          `++++ forces #### enourmous cock between xxxx's tight pussy lips`,
        ],
        sizeM: [
          `++++ rubs xxxx's clit dominantly`,
          `++++ slaps xxxx's pussy lips with #### enourmous, erect cock`,
          `++++ fucks xxxx's cunt roughly`,
        ],
        sizeL: [
          `++++'s enourmous cock is rubbed around xxxx's pussy`,
          `++++ pushes #### enourmous cock into xxxx's pussy, rubbing it around`,
          `++++ pushes #### way roughly into xxxx's juicy cunt`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's backdoor`,
          `++++ batters xxxx's arse with #### hungry, giant cock`,
          `++++ pushes #### enourmous cock roughly into xxxx's tight arse`,
          `++++ grabs xxxx's arse cheeks and forces #### enourmous cock into xxxx's tight back passage`,
        ],
        sizeM: [
          `++++ rubs ====self dominantly between xxxx's arsecheeks`,
          `++++ slaps xxxx's second cunt with #### giant cock`,
          `++++ pushes #### way roughly into xxxx's warm arse`,
          `++++ grabs xxxx's arse cheeks and forces #### enourmous cock into xxxx's fresh back passage`,
        ],
        sizeL: [
          `++++'s enourmous cock is rubbed around xxxx's arse entrance`,
          `++++ pushes #### cock into xxxx's arse, degrading ==== for ==== gaping hole`,
          `++++ pushes #### way roughly into xxxx's loose arse`,
          `++++ grabs xxxx's arse cheeks and pushes #### fat cock into xxxx's open back passage`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.vagina]: {
    sizeOpt: 3,
    sizeS: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's thigh`,
          `++++ rubs #### sticky lady cavern over xxxx's arms`,
          `++++ runs #### beautiful pussy over xxxx's soft torso`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### pussy lips over xxxx's tiny tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeM: [
          `++++ rubs #### pussy lips over xxxx's full tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeL: [
          `++++ rubs #### pussy lips over xxxx's heavy tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's mouth`,
          `++++ rubs #### sticky lady cavern over xxxx's face`,
          `++++ slides #### beautiful pussy over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock`,
          `++++ presses #### cunt against xxxx's cute, hard shaft`,
          `++++ slowly slides xxxx's tiny cock into #### slippery, tight pussy`,
        ],
        sizeM: [
          `++++ rides xxxx's hard cock`,
          `++++ presses #### cunt against xxxx's hard shaft, rubbing herself along it`,
          `++++ slowly slides xxxx's hard cock into #### slippery, tight pussy`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock`,
          `++++ presses #### cunt against xxxx's long, hard shaft, rubbing herself along it's sizable length`,
          `++++ slowly pushes the glans of xxxx's giant cock into #### slippery, tight pussy`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's`,
          `++++ grinds against xxxx's sopping wet pussy`,
          `++++ roughly brushes #### clit against xxxx's`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ grinds #### slippery pussy lips over xxxx's soft buttcheeks as she pins them to the floor`,
        ],
      },
    },
    sizeM: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's thigh`,
          `++++ rubs #### sticky lady cavern over xxxx's arms`,
          `++++ pushes #### beautiful pussy over xxxx's soft torso`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### pussy lips over xxxx's tiny tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeM: [
          `++++ rubs #### pussy lips over xxxx's full tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeL: [
          `++++ rubs #### pussy lips over xxxx's heavy tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's mouth`,
          `++++ rubs #### sticky lady cavern over xxxx's face`,
          `++++ opens #### beautiful pussy over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock`,
          `++++ presses #### cunt against xxxx's cute, hard shaft`,
          `++++ slowly slides xxxx's tiny cock into #### slippery, wet pussy`,
        ],
        sizeM: [
          `++++ rides xxxx's hard cock`,
          `++++ presses #### cunt against xxxx's hard shaft, rubbing herself along it`,
          `++++ slowly slides xxxx's hard cock into #### slippery, enveloping pussy`,
        ],
        sizeL: [
          `++++ rides the top xxxx's enormous cock`,
          `++++ presses #### cunt against xxxx's long, hard shaft, rubbing herself along it's sizable length`,
          `++++ slowly pushes the top of xxxx's giant cock into #### slippery wet pussy`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's`,
          `++++ grinds against xxxx's sopping wet pussy`,
          `++++ roughly brushes #### clit against xxxx's`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ grinds #### slippery pussy lips over xxxx's soft buttcheeks as she pins them to the floor`,
        ],
      },
    },
    sizeL: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's thigh`,
          `++++ rubs #### sticky lady cavern over xxxx's arms`,
          `++++ pushes #### beautiful pussy over xxxx's soft torso`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### pussy lips over xxxx's tiny tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeM: [
          `++++ rubs #### pussy lips over xxxx's full tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeL: [
          `++++ rubs #### pussy lips over xxxx's heavy tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's mouth`,
          `++++ rubs #### sticky lady cavern over xxxx's face`,
          `++++ pushes #### beautiful pussy over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock`,
          `++++ presses #### cunt against xxxx's cute, hard shaft`,
          `++++ easily slides xxxx's tiny cock into #### slippery, warm pussy`,
        ],
        sizeM: [
          `++++ rides xxxx's hard cock`,
          `++++ presses #### cunt against xxxx's hard shaft, rubbing herself along it`,
          `++++ easily slides xxxx's hard cock into #### slippery, tight pussy`,
        ],
        sizeL: [
          `++++ rides xxxx's enormous cock`,
          `++++ presses #### cunt against xxxx's long, hard shaft, rubbing herself along it's sizable length`,
          `++++ slides ####self over xxxx's giant cock, taking the giant shaft entirely into #### pussy`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's`,
          `++++ grinds against xxxx's sopping wet pussy`,
          `++++ roughly brushes #### clit against xxxx's`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ grinds #### slippery pussy lips over xxxx's soft buttcheeks as she pins them to the floor`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.anus]: {
    sizeOpt: 3,
    sizeS: {
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### arsecheeks over xxxx's mouth`,
          `++++ rubs #### arsecheeks over xxxx's face`,
          `++++ pushes #### beautiful backdoor over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's cute, hard shaft`,
          `++++ slowly slides xxxx's tiny cock into #### slippery, tight arse`,
        ],
        sizeM: [
          `++++ rides the top of xxxx's hard cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's hard shaft, rubbing #### cheeks along it`,
          `++++ slowly slides xxxx's hard cock into #### slippery, tight arse`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's long, hard shaft, rubbing ####self along it's sizable length`,
          `++++ slowly pushes the glans of xxxx's giant cock into #### slippery, tight arsehole`,
        ],
      },
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's body`,],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's breasts`,],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's clit`,],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's`,],
      },
    },
    sizeM: {
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### arsecheeks over xxxx's mouth`,
          `++++ rubs #### arsecheeks over xxxx's face`,
          `++++ pushes #### beautiful backdoor over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's cute, hard shaft`,
          `++++ easily slides xxxx's tiny cock into #### slippery, hungry arse`,
        ],
        sizeM: [
          `++++ rides the top of xxxx's hard cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's hard shaft, rubbing #### cheeks along it`,
          `++++ snugly slides xxxx's hard cock into #### slippery, hungry arse`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's long, hard shaft, rubbing ####self along it's sizable length`,
          `++++ slowly pushes the top of xxxx's giant cock into #### slippery, tight arsehole`,
        ],
      },
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's body`,],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's breasts`,],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's clit`,],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's`,],
      },
    },
    sizeL: {
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### arsecheeks over xxxx's mouth`,
          `++++ rubs #### arsecheeks over xxxx's face`,
          `++++ pushes #### beautiful backdoor over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's cute, hard shaft`,
          `++++ easily slides xxxx's tiny cock into #### slippery, hungry arse`,
        ],
        sizeM: [
          `++++ rides the top of xxxx's hard cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's hard shaft, rubbing #### cheeks along it`,
          `++++ easily slides xxxx's hard cock into #### slippery, hungry arse`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock, with #### snug anal passage`,
          `++++ presses #### arsecheeks against xxxx's long, hard shaft, rubbing ####self along it's sizable length`,
          `++++ slides ####self over xxxx's giant cock, taking the giant shaft entirely into #### arsehole`,
        ],
      },
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's body`,],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's breasts`,],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's clit`,],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's`,],
      },
    },
  },
};
export default Dominate;
